import { useState, useEffect } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import RegisterSignupModal from './RegisterSignupModal';
import ClientLoginModal from './ClientLoginModal';

import { SocketProvider } from '../../context/SocketContext';

export default function ClientLayout() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);

  // Scroll to top of the page on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <SocketProvider userType="client">
      <Navbar 
        onLoginClick={() => setLoginModalOpen(true)}
        onTrialClick={() => {
          if (pathname !== '/') {
            navigate('/#trial-section');
            // If we are navigating to the home page, the element might not be rendered yet.
            // A short delay helps ensure the DOM is ready for scrollIntoView.
            setTimeout(() => {
              document.getElementById('trial-section')?.scrollIntoView({ behavior: 'smooth' });
              if (!localStorage.getItem('trialToken')) {
                setLoginModalOpen(true);
              }
            }, 100);
          } else {
            document.getElementById('trial-section')?.scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => {
              if (!localStorage.getItem('trialToken')) {
                setLoginModalOpen(true);
              }
            }, 600); // Wait for scroll to finish
          }
        }} 
      />
      
      <main style={{ minHeight: 'calc(100vh - 350px)' }}>
        <Outlet />
      </main>
      
      <Footer />

      {/* Shared Modals */}
      {modalOpen && <RegisterSignupModal onClose={() => setModalOpen(false)} />}
      
      {loginModalOpen && (
        <ClientLoginModal 
          onClose={() => setLoginModalOpen(false)} 
          onSwitchToSignup={() => {
            setLoginModalOpen(false);
            setModalOpen(true);
          }}
        />
      )}
    </SocketProvider>
  );
}
